const timeFormat = (time) => {
  try {
    if (time === undefined) {
      return '--'
    } else if (time) {
      var oDate = new Date(time * 1000)

      var y = oDate.getFullYear()
      var m = String(oDate.getMonth() + 1).padStart(2, 0)
      var d = String(oDate.getDate()).padStart(2, 0)

      var h = String(oDate.getHours()).padStart(2, 0)
      var min = String(oDate.getMinutes()).padStart(2, 0)
      var s = String(oDate.getSeconds()).padStart(2, 0)

      return `${y}-${m}-${d} ${h}:${min}:${s}`
    } else {
      return '--'
    }
  } catch (e) {
    return '--'
  }
}

const getSummary = (str) => {
  let tmpStr = str.replace(/<(img).*?>/g, '[图片] ') // 替换所有的图片
  tmpStr = tmpStr.replace(/<\/p>.*?>/g, ' ') // 替换所有换行符
  tmpStr = tmpStr.replace(/<[^>]+>/g, '') // 去掉所有的html标记
  tmpStr = tmpStr.replace(/&nbsp;/g, ' ') // 去掉所有空格
  return tmpStr
}

const reasonObj = {
  '1': '垃圾广告信息(广告、照片、推广、测试等内容)',
  '2': '违规内容(色情、暴力、血腥、敏感信息等)',
  '3': '不友善内容(人身攻击、挑衅辱骂、恶意行为等)'
}

const auth2BitUser = [
  '设备编辑',
  '参数设置',
  '提醒推送',
  '模块管理',
  '数据服务',
  '软件版本更新',
  '控制器操作'
]
const auth2BitPlatform = [
  '读',
  '写',
  '',
  ''
]
const getAuthorityUser = (array) => {
  let authority = '只读 '
  array.map((authItem, idx) => {
    if (Number(authItem)) { // 为true或为 1
      authority = authority === '只读 ' ? '' : authority
      authority = authority + auth2BitUser[idx] + '/'
    }
  })
  return authority.substring(0, authority.length - 1)
}

const getAuthorityPlatform = (array) => {
  let authority = ''
  array.map((authItem, idx) => {
    if (Number(authItem)) { // 为true或为 1
      authority = authority + auth2BitPlatform[idx] + '/'
    }
  })
  return authority.substring(0, authority.length - 1)
}
const getReason = (str) => {
  return reasonObj[str]
}

export default {
  timeFormat,
  getSummary,
  getReason,
  getAuthorityUser,
  getAuthorityPlatform
}



// WEBPACK FOOTER //
// ./src/filters/index.js